var _rect, _circle, _line, _line2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoSupportCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 44,
    fill: "#7B66F2"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    y1: 49.4,
    x2: 82.5,
    y2: 49.4,
    stroke: "white",
    strokeWidth: 1.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    y1: 54.4,
    x2: 82.5,
    y2: 54.4,
    stroke: "white",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2594 43.2511C80.4704 42.4507 79.3949 42.0053 78.2745 42H45.2294C44.1089 42.0052 43.0334 42.4507 42.2393 43.2511C41.4455 44.0516 40.998 45.1353 40.998 46.2649V61.4597C38.9681 63.7538 38.1087 66.8588 38.6667 69.8828C39.2194 72.9015 41.1289 75.4897 43.8424 76.8977C46.551 78.3058 49.7517 78.3666 52.5101 77.07C55.2741 75.7732 57.2839 73.261 57.9572 70.2676H78.2735C79.394 70.2627 80.4695 69.8169 81.2636 69.0165C82.0529 68.2161 82.5 67.1323 82.5 66.0027V46.2646C82.5 45.1349 82.0529 44.0512 81.2587 43.2508L81.2594 43.2511ZM47.9728 76.8677C45.7264 76.7716 43.596 75.8041 42.0382 74.1629C40.4803 72.522 39.6112 70.3389 39.6112 68.0699C39.6112 65.9275 40.385 63.8557 41.7919 62.2552L54.1187 74.6798C52.4251 76.1793 50.224 76.9645 47.9728 76.8681V76.8677ZM54.9077 73.8845L42.5809 61.4599C44.8221 59.4643 47.9227 58.7653 50.7919 59.6061C53.6611 60.4469 55.9075 62.711 56.7417 65.6031C57.5759 68.5003 56.8823 71.6207 54.9077 73.8845ZM81.3849 66.0033C81.3849 66.834 81.0583 67.6341 80.4755 68.2219C79.8875 68.8094 79.0986 69.1386 78.2744 69.1386L58.1441 69.1438C58.4455 66.3378 57.5513 63.5369 55.6819 61.4349C53.8125 59.3381 51.1491 58.1374 48.3503 58.1374C46.0739 58.1322 43.8727 58.9274 42.1143 60.3811V46.265C42.1143 45.4343 42.4461 44.6343 43.0289 44.0465C43.6118 43.459 44.4058 43.1298 45.23 43.1245H78.2751C79.0993 43.1297 79.8883 43.4586 80.4762 44.0465C81.0591 44.6339 81.3857 45.4343 81.3857 46.265L81.3849 66.0033Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoSupportCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-support-card.33737be19c482b7f9ef7cf444b5a6596.svg";